<template>
    <div class="col-md-12">
        <div class="h2">Step Transport Addresses</div>

        <form @submit.prevent="updateAddresses">
            <div class="container-fluid bg-light py-3">
                <div class="row">
                    <div class="col-md-12">
                        <div class="p-4 mb-3 bg-white rounded-lg">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="h4 mb-3">Terminals</div>
                                <a @click="isEditing = !isEditing" v-if="!isEditing">
                                    <span class="material-icons-outlined cursor-pointer text-primary">edit</span>
                                </a>
                                <a href="#" v-if="isEditing" @click="isEditing = false">
                                    <small>cancel editing</small>
                                </a>
                            </div>

                            <div class="">

                                <div class="container-fluid bg-light py-3">
                                    <div class="row">
                                        <div v-for="(address,k) in addresses" class="col-md-4">
                                            <div class="col-md-12">
                                                <div v-if="isEditing">
                                                    <div class="form-group">
                                                        <div
                                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditing, 'border-danger': address.nickname=='' && isSubmit}">
                                                            <input type="text"
                                                                   required
                                                                   autocomplete="off"
                                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                                   v-model="address.nickname"
                                                                   :disabled="!isEditing"
                                                                   :class="{view: !isEditing}">
                                                        </div>
                                                    </div>

                                                    <div class="form-group">
                                                        <div
                                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditing, 'border-danger': address.name=='' && isSubmit}">
                                                            <input type="text"
                                                                   required
                                                                   autocomplete="off"
                                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                                   v-model="address.name"
                                                                   :disabled="!isEditing"
                                                                   :class="{view: !isEditing}">
                                                        </div>
                                                    </div>

                                                    <div class="form-group">
                                                        <div
                                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditing, 'border-danger': address.street=='' && isSubmit}">
                                                            <input type="text"
                                                                   required
                                                                   autocomplete="off"
                                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                                   v-model="address.street"
                                                                   :disabled="!isEditing"
                                                                   :class="{view: !isEditing}">
                                                        </div>
                                                    </div>

                                                    <div class="form-group">
                                                        <div
                                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditing, 'border-danger': address.zip=='' && isSubmit}">
                                                            <input type="text"
                                                                   required
                                                                   autocomplete="off"
                                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                                   v-model="address.zip"
                                                                   :disabled="!isEditing"
                                                                   :class="{view: !isEditing}">
                                                            <div class="help-block with-errors"></div>
                                                        </div>
                                                    </div>

                                                    <div class="form-group">
                                                        <div
                                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditing, 'border-danger': address.city=='' && isSubmit}">
                                                            <input type="text"
                                                                   required
                                                                   autocomplete="off"
                                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                                   v-model="address.city"
                                                                   :disabled="!isEditing"
                                                                   :class="{view: !isEditing}">
                                                            <div class="help-block with-errors"></div>
                                                        </div>
                                                    </div>

                                                    <div class="form-group">
                                                        <div
                                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                                            <select class="form-control  border-0 py-0 shadow-none">
                                                                <option value="1" selected>Denmark</option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div class="form-group">
                                                        <div
                                                            class="align-items-center bg-white border rounded-lg div-focus">
                                                            <v-select
                                                                required
                                                                :options="k===0 ? locationList0 : locationList1"
                                                                v-model="address.receiving_location"
                                                                label="name"
                                                            >
                                                            </v-select>
                                                        </div>
                                                    </div>

                                                    <div class="form-group">
                                                        <button class="btn btn-danger"
                                                                @click.prevent="deleteAddress(address.id)"
                                                        >Delete</button>
                                                    </div>

                                                </div>
                                                <div v-else>
                                                    <b>{{ address.nickname }}</b> <br/>
                                                    {{ address.name }} <br/>
                                                    {{ address.street }},
                                                    {{ address.zip }}
                                                    {{ address.city }},
                                                    Denmark <br/><br/>

                                                    receiving location: <br/>
                                                    {{ address.receiving_location ? address.receiving_location.name : '' }}

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="">
                                    <button v-if="isEditing===true" type="submit" class="btn btn-primary mt-3"
                                            @click="validation()">
                                        Save
                                    </button>
                                </div>

                                <br/>
                                <br/>

                                <a href="/settings/new-step-address"
                                   class="btn btn-success d-inline-flex align-items-center"
                                   @click="isEditing = !isEditing"
                                   v-if="!isEditing">
                                    <span class="material-icons-outlined cursor-pointer mr-2">add_circle_outline</span>
                                    <span>Add warehouse</span>
                                </a>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </form>


    </div>
</template>

<script>

export default {
    name: "StepAddresses",
    data() {
        return {
            locationList0: [
                {id: '', name: ''},
            ],
            locationList1: [
                {id: '', name: ''},
            ],
            isEditing: false,
            addresses: {},
            isSubmit: false
        }
    },
    methods: {
        validation() {
            this.isSubmit = true;
        },
        fetchData() {
            axios.get('/settings/get-step-addresses')
                .then(({data}) => {
                    this.addresses = data.data;
                    let name;
                    this.addresses.forEach((address, i) => {
                        if (address.receiving_location) {
                            name = `${this.addresses[i].receiving_location.name} (${this.addresses[i].nickname})`
                            this.$set(this.addresses[i].receiving_location, 'name', name);
                        }
                    })
                }).catch(error => this.booking = []);
            axios.get('/location-list-select')
                .then(({data}) => {
                    Object.entries(data).forEach(entry => {
                        const [key, value] = entry;
                        if (value.warehouse.nickname === 'Brøndby') {
                            this.locationList0.push({
                                id: value.id,
                                name: `${value.name} (${value.warehouse.nickname})`,
                            });
                        } else {
                            this.locationList1.push({
                                id: value.id,
                                name: `${value.name} (${value.warehouse.nickname})`,
                            });
                        }
                    });
                }).catch();
        },
        updateAddresses() {
            axios.patch(`/settings/update-step-addresses`, this.addresses).then((response) => {
                window.location.reload();
            }).catch(err => console.log(err))
        },
        deleteAddress(id) {
            if (confirm("Are you sure you want to delete this address?")) {
                axios.delete(`/settings/delete-step-address/${id}`).then((response) => {
                    window.location.reload();
                }).catch(err => console.log(err.response));
            }
        }
    },
    created() {
        return this.fetchData()
    },
}

</script>
